<template lang="pug">
div(:class="$style.loginForm" v-show="value")
  div(:class="[$style.formContainer, 'container']")
    a(:class="$style.closeBtn"
      @click.prevent="closeForm")
      Icon(
        :size="28"
        name="i:circle-xmark-regular")
    form(action="/login-with-credentials" method="post" enctype="multipart/form-data" id="login-form" accept-charset="UTF-8")
      div
        <input type="hidden" name="__IDENTlogin-form__" value="1">
        <input type="hidden" name="__TIMESTAMP" :value="nonceTimestamp">
        <input type="hidden" name="__fw-token" :value="nonce">

      div(:class="$style.fieldSet")
        div(:class="$style.formTitle") Log in
        div(:class="[$style.formField, 'login-email']")
          label(:class="$style.formLabel" for="email") E-mail address:
          input(:class="$style.formInput" name="email" id="email" type="text" value="" maxlength="255" placeholder="Enter your email address...")

        div(:class="[$style.formField, 'login-password']")
          label(:class="$style.formLabel" for="password") Password
          input(:class="$style.formInput" name="password" id="password" type="password" value="" maxlength="50" placeholder="Enter your password...")

        div(:class="[$style.formField, 'login-submit']")
          input(:class="$style.formBtn" id="submit-login" type="submit" name="submit-login" value="Log in")

        div(:class="[$style.formField, 'login-forgot']")
          a(:class="$style.formLink" href="/request-password" rel="nofollow") Forgot Password?

</template>

<script lang="ts">
import { defineComponent } from "vue"
import { mapGetters } from "vuex"
import { GET_FW_TOKEN, GET_FW_TOKEN_TIMESTAMP } from "~/store/auth"

export default defineComponent({
  name: "LoginForm",

  props: {
    value: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters("auth", {
      nonce: GET_FW_TOKEN,
      nonceTimestamp: GET_FW_TOKEN_TIMESTAMP
    })
  },

  methods: {
    closeForm(): void {
      this.$emit("close")
    }
  }
})
</script>

<style lang="scss" module>
.loginForm {
  @apply bg-blue-dark text-white;
  /* padding: 25px 15px; */
  font-weight: 600;
}

.formContainer {
  @apply relative px-ds-md py-ds-ml;
}
.closeBtn {
  position: absolute;
  top: 6px;
  right: 18px;
  color: #fff;
  font-size: 26px;
  text-decoration: none;
  /* height: 40px; */
}
.fieldSet {
  display: block;
}
@screen lg {
  .fieldSet {
    display: flex;
    column-gap: 10px;
  }
}

.formTitle {
  font-size: 28px;
  margin: 24px 20px 0 0;
}
.formField {
  font-size: 16px;
}
.formLabel {
  display: block;
  font-size: 14px;
  margin-top: 15px;
  margin-bottom: 5px;
}
@screen lg {
  .formLabel {
    margin-top: 0px;
  }
}

.formInput {
  display: block;
  width: 100%;
  height: 42px;
  padding: 6px 12px;
  font-size: 16px;
  line-height: 1.42857143;
  color: #555555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  transition:
    border-color ease-in-out 0.15s,
    box-shadow ease-in-out 0.15s;
}

@screen lg {
  .formInput {
    height: 36px;
  }
}

.formBtn {
  /* btn */
  display: inline-block;
  margin-bottom: 0;
  font-weight: normal;
  text-align: center;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  background-image: none;
  border: 1px solid transparent;
  white-space: nowrap;
  padding: 6px 12px;
  font-size: 16px;
  line-height: 1.42857143;
  border-radius: 4px;
  appearance: button;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  /* btn-primary */
  color: #fff;
  background-color: #41a5dd;
  border-color: #2e6da4;

  /* login-submit */
  margin-top: 27px;
}

.formLink {
  display: block;
  color: #fff;
  font-size: 14px;
  text-decoration: underline;

  /* login-forgot */
  margin-top: 24px;
}

@screen lg {
  .formLink {
    margin-top: 34px;
    margin-left: 10px;
  }
}
</style>
